module.exports = __webpack_public_path__ + "img/ugreen.8531af0d.png";